// extracted by mini-css-extract-plugin
module.exports = {"root":"ServicePortalSidebar_root__NfRof","header":"ServicePortalSidebar_header__RdkBX","container":"ServicePortalSidebar_container__qy6U5"};